// @flow

export const fetchServiceProvidersByText = async (apiIndex: ApiIndex<MapApi>, text: string, rows: number): Promise<ServiceProvider[]> => {
  const params = `q=${text}&rows=${rows}`
  const apiPath = apiIndex.apis['partner']['service-providers']['list']['url']
  const url = `${apiIndex.basePath}${apiPath}?${params}`
  const response = await fetch(url, {
    headers: {
      'content-type': 'application/json; version=2.0',
      'Accept': 'application/json; version=2.0',
    },
  })

  if (response.status === 200) {
    return await response.json()
  } else {
    throw new Error(await response.text())
  }
}